<template>
  <DashboardPanel
    panel-id="v-pills-interviews"
    aria-labelledby="v-pills-interviews-tab"
    title="Scheduled interviews"
    :subtitle="interviews.length ? `${interviews.length} upcoming or past interview${interviews.length === 1 ? '' : 's'}` : 'Video interviews scheduled by employers'"
  >
    <div v-if="interviews.length" class="hc-activity-list">
      <article
        v-for="interview in interviews"
        :key="interview.room_id"
        class="hc-activity-card"
        :class="cardClass(interview.interview_time_from)"
      >
        <h3 class="hc-activity-card__title">{{ interview.job_designation }}</h3>
        <p class="hc-activity-card__meta"><strong>Interviewer:</strong> {{ interview.interviewer }}</p>
        <div class="hc-activity-card__footer">
          <p class="hc-activity-card__detail">
            <strong>Date:</strong> {{ interview.interview_date }}
            <span class="mx-1">·</span>
            <strong>Time:</strong> {{ getTime(interview.interview_time_from) }} – {{ getTime(interview.interview_time_to) }}
          </p>
          <a
            v-if="checkDate(interview.interview_time_from) === 'active'"
            :href="interview.interview_link"
            class="hc-status-pill hc-status-pill--join"
          >Join</a>
          <span
            v-else
            class="hc-status-pill"
            :class="'hc-status-pill--' + checkDate(interview.interview_time_from)"
            v-b-tooltip.hover
            :title="getHelpText(interview.interview_time_from)"
          >{{ checkDate(interview.interview_time_from) }}</span>
        </div>
      </article>
    </div>

    <div v-else class="hc-panel__empty">
      <i class="mdi mdi-calendar-clock hc-panel__empty-icon" aria-hidden="true"></i>
      <h3>No interviews scheduled</h3>
      <p>When an employer invites you for a video interview, it will appear here with date, time, and a join link.</p>
    </div>
  </DashboardPanel>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import DashboardPanel from './Dashboard/DashboardPanel.vue';
import '../assets/hire.css';

export default {
  name: 'ScheduledInterviews',
  components: { DashboardPanel },
  data() {
    return {
      action: new Actions(),
      interviews: [],
    };
  },
  beforeMount() {
    this.loadInterviews();
  },
  methods: {
    loadInterviews() {
      const token = this.$cookies.get('hire-seeker')?.token;
      if (!token) return;
      this.action.scheduledInterviews(token).then((res) => {
        if (res.meta.success) {
          this.interviews = res.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    getTime(ts) {
      const date = new Date(ts * 1000);
      return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    },
    checkDate(ts) {
      const expTs = ts + 1800;
      const currentTime = new Date().getTime() / 1000;
      if (currentTime < ts) return 'upcoming';
      if (ts < currentTime && currentTime < expTs) return 'active';
      return 'expired';
    },
    getHelpText(ts) {
      const expTs = ts + 1800;
      const currentTime = new Date().getTime() / 1000;
      if (currentTime < ts) return 'Interview not started yet, retry at the scheduled time';
      if (currentTime > expTs) return 'Interview link has expired';
      return '';
    },
    cardClass(ts) {
      const status = this.checkDate(ts);
      if (status === 'active') return 'hc-activity-card--active';
      if (status === 'expired') return 'hc-activity-card--expired';
      return '';
    },
  },
};
</script>
